var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUudSpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.589 48.949a1.744 1.744 0 0 1 2.489.035c2.605 2.717 6.557 3.926 10.394 2.816 3.838-1.11 6.566-4.25 7.365-7.951a1.76 1.76 0 0 1 2.096-1.362 1.785 1.785 0 0 1 1.343 2.125c-1.065 4.933-4.705 9.136-9.838 10.62-5.133 1.485-10.412-.139-13.884-3.76a1.802 1.802 0 0 1 .035-2.523Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m54.685 3.155-10.519 7.76L29.28.319 18.432 15.245 6.173 11.282l6.954 21.472v.598c-3.96.17-7.188 3.482-7.188 7.544 0 4.17 3.332 7.55 7.44 7.55h.538c2.484 8.43 10.505 14.582 19.987 14.582 9.482 0 17.503-6.152 19.987-14.582l.783-.003c3.995-.132 7.195-3.46 7.195-7.547l-.004-.25c-.127-3.968-3.271-7.162-7.18-7.297V3.155ZM16.747 33.079l-.032 9.838c0 8.965 7.496 16.291 16.854 16.462l.335.004c9.402 0 17.008-7.221 17.186-16.146l.002-15.99-34.345 5.832Zm41.53 7.817c0 2.07-1.586 3.763-3.592 3.897v-7.794l.395.047c1.815.314 3.197 1.918 3.197 3.85Zm-45.353-3.879.199-.019v7.795c-2.006-.134-3.592-1.828-3.592-3.897 0-2.001 1.482-3.65 3.393-3.879Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.965 72.82v10.152c0 2.785 1.652 5.375 4.771 5.375 3.12 0 4.772-2.59 4.772-5.375V72.82h5.965v10.153c0 6.267-4.807 11.347-10.737 11.347S0 89.24 0 82.972V72.82h5.965Zm23.167 10.152V72.82h-5.964v10.153c0 6.267 4.806 11.347 10.736 11.347 5.93 0 10.736-5.08 10.736-11.347V72.82h-5.964v10.153c0 2.785-1.775 5.375-4.772 5.375-2.997 0-4.772-2.59-4.772-5.375Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M57.072 72.82c5.93 0 10.736 4.812 10.736 10.75 0 5.936-4.807 10.75-10.736 10.75H46.335v-21.5h10.737Zm.28 5.374H52.3v10.75h5.052c2.355 0 4.491-2.406 4.491-5.375 0-2.968-2.136-5.375-4.49-5.375Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUudSpo);
export default __webpack_public_path__ + "static/media/uud_spo.79335e3271d0f0468b5900d3c1f13c88.svg";
export { ForwardRef as ReactComponent };